// On-chain metrics curated for the Academy intro page. Each metric ships
// with a 5-tier interpretation table (color-coded) so the page can render
// a consistent "what does this signal mean?" panel without extra logic.

export const METRICAS_ONCHAIN = [
  {
    id: "fear-greed",
    nombre: "Fear & Greed Index",
    dificultad: "basica",
    descripcion: "El índice más usado para medir el sentimiento general del mercado cripto. Combina volatilidad, momentum, volumen, redes sociales, dominancia y búsquedas de Google en una escala de 0 (Miedo Extremo) a 100 (Codicia Extrema). Warren Buffett: «Sé codicioso cuando otros tienen miedo, y temeroso cuando otros son codiciosos».",
    apiUrl: "https://api.alternative.me/fng/",
    interpretacion: [
      { rango: "0-25", senal: "Miedo Extremo", color: "green",
        descripcion: "Mercado en pánico. Históricamente señal de compra para holders a largo plazo. Los institucionales acumulan silenciosamente." },
      { rango: "26-45", senal: "Miedo", color: "lime",
        descripcion: "Sentimiento negativo. El retail está saliendo. Oportunidad para analizar setups alcistas." },
      { rango: "46-55", senal: "Neutral", color: "yellow",
        descripcion: "Mercado en equilibrio. Sin sesgo claro. Esperar confirmación de dirección." },
      { rango: "56-75", senal: "Codicia", color: "orange",
        descripcion: "Euforia moderada. El mercado sube pero con cuidado. Reducir tamaños o empezar a tomar beneficios parciales." },
      { rango: "76-100", senal: "Codicia Extrema", color: "red",
        descripcion: "Euforia máxima. Históricamente señal de techo de mercado. Los institucionales distribuyen. Máxima precaución." },
    ],
  },
  {
    id: "nupl",
    nombre: "NUPL — Net Unrealized Profit/Loss",
    dificultad: "intermedia",
    descripcion: "Mide si los holders de Bitcoin están, en conjunto, en beneficio o en pérdida no realizada. Se calcula como (Market Cap − Realized Cap) / Market Cap. Es uno de los indicadores más fiables para identificar techos y suelos de ciclo.",
    interpretacion: [
      { rango: "> 0.75", senal: "Euforia", color: "red",
        descripcion: "La gran mayoría tiene grandes beneficios no realizados. Zona de distribución institucional. Históricamente precede correcciones del 50-80%." },
      { rango: "0.5-0.75", senal: "Creencia", color: "orange",
        descripcion: "Mercado madurando el ciclo alcista. Aún con recorrido pero con más riesgo." },
      { rango: "0.25-0.5", senal: "Optimismo", color: "lime",
        descripcion: "Fase alcista saludable. Buen punto de entrada en retrocesos." },
      { rango: "0-0.25", senal: "Esperanza", color: "green",
        descripcion: "Transición. El mercado se recupera de un suelo. Oportunidad de acumulación." },
      { rango: "< 0", senal: "Capitulación", color: "green",
        descripcion: "La mayoría está en pérdidas. Pánico máximo. Históricamente zona de suelo de ciclo. Mejor oportunidad de compra a largo plazo." },
    ],
  },
  {
    id: "exchange-flow",
    nombre: "Exchange Inflow / Outflow",
    dificultad: "basica",
    descripcion: "Rastrea el movimiento de Bitcoin hacia y desde los exchanges centralizados. Cuando los holders envían BTC a exchanges, sugieren intención de vender (bearish). Cuando retiran BTC de los exchanges a wallets privadas, sugieren intención de holdear (bullish). Los flujos netos hacia exchanges suelen preceder caídas.",
    interpretacion: [
      { rango: "Inflow alto", senal: "Bajista", color: "red",
        descripcion: "Mucho BTC entrando a exchanges. Preparación para vender. Aumenta la presión vendedora a corto plazo." },
      { rango: "Outflow alto", senal: "Alcista", color: "green",
        descripcion: "Mucho BTC saliendo de exchanges. Los holders guardan en wallets propias. Reduce la oferta disponible para vender." },
      { rango: "Flujo neutro", senal: "Sin señal", color: "yellow",
        descripcion: "Esperar confirmación de precio. No es un trigger por sí solo." },
    ],
  },
  {
    id: "mvrv",
    nombre: "MVRV Ratio",
    dificultad: "intermedia",
    descripcion: "Market Value to Realized Value. Compara el precio actual de mercado con el precio promedio al que los holders compraron su BTC (precio realizado). Un MVRV alto significa que los holders tienen grandes beneficios no realizados y pueden vender. Un MVRV bajo (cercano a 1) históricamente marca suelos de ciclo.",
    interpretacion: [
      { rango: "MVRV > 3.5", senal: "Sobrevaluación extrema", color: "red",
        descripcion: "Los holders tienen en promedio 3.5x su inversión en beneficio. Históricamente zona de techo. Solo 3 veces en la historia de BTC." },
      { rango: "MVRV 2-3.5", senal: "Alerta", color: "orange",
        descripcion: "Mercado caro pero puede continuar. Reducir exposición gradualmente." },
      { rango: "MVRV 1-2", senal: "Saludable", color: "lime",
        descripcion: "Mercado razonablemente valorado." },
      { rango: "MVRV < 1", senal: "Capitulación", color: "green",
        descripcion: "BTC cotiza por debajo del precio promedio de compra de todos los holders. Zona históricamente de mejor oportunidad de compra a largo plazo." },
    ],
  },
  {
    id: "dominancia-btc",
    nombre: "Dominancia de Bitcoin (BTC.D)",
    dificultad: "basica",
    descripcion: "Porcentaje de la capitalización total de cripto que representa Bitcoin. Indicador clave para saber cuándo rotar entre BTC y altcoins. Ciclo típico: BTC sube primero (D sube) → ETH y large caps siguen → altcoins pequeñas estallan (D cae) → todo colapsa → BTC vuelve a liderar.",
    apiUrl: "https://api.coingecko.com/api/v3/global",
    interpretacion: [
      { rango: "D > 60% subiendo", senal: "BTC season", color: "orange",
        descripcion: "Capital fluyendo hacia BTC. Mercado conservador. Momento de tener más BTC que altcoins." },
      { rango: "D 50-60%", senal: "Transición", color: "yellow",
        descripcion: "BTC consolidando liderazgo. Empezar a mirar ETH y large caps." },
      { rango: "D 40-50% bajando", senal: "Altcoin season", color: "lime",
        descripcion: "Rotar hacia altcoins de calidad. ETH, SOL, BNB lideran." },
      { rango: "D < 40%", senal: "Euforia altcoins", color: "green",
        descripcion: "Altcoin season plena. Las small caps se multiplican. Máximo riesgo — el siguiente movimiento suele ser un crash altcoins." },
    ],
  },
  {
    id: "puell-multiple",
    nombre: "Puell Multiple",
    dificultad: "avanzada",
    descripcion: "Mide la rentabilidad de los mineros de Bitcoin comparando el valor diario de los BTC minados con el promedio anual. Los mineros son vendedores estructurales de BTC para pagar costes operativos. Un Puell alto significa que los mineros están muy rentables y pueden vender más. Un Puell muy bajo históricamente marca suelos.",
    interpretacion: [
      { rango: "Puell > 4", senal: "Techo de ciclo", color: "red",
        descripcion: "Mineros muy rentables. Presión vendedora de mineros alta. Históricamente zona de techo (solo en bull markets extremos)." },
      { rango: "Puell 1-4", senal: "Mercado activo", color: "orange",
        descripcion: "Producción y demanda equilibradas." },
      { rango: "Puell 0.3-0.5", senal: "Capitulación mineros", color: "green",
        descripcion: "Mineros en dificultades. Los más débiles se rinden y el precio suele marcar suelo. Históricamente oportunidad de compra de ciclo." },
    ],
  },
];

export const COLOR_DOT = {
  green: "bg-emerald-400",
  lime: "bg-lime-400",
  yellow: "bg-yellow-400",
  orange: "bg-orange-400",
  red: "bg-red-400",
};

export const DIFICULTAD_COLOR = {
  basica: "border-emerald-400/40 bg-emerald-400/[0.08] text-emerald-200",
  intermedia: "border-amber-400/40 bg-amber-400/[0.08] text-amber-200",
  avanzada: "border-red-400/40 bg-red-400/[0.08] text-red-200",
};

export const RECURSOS_EXTERNOS = [
  { nombre: "Glassnode", url: "https://glassnode.com",
    desc: "El estándar profesional de métricas on-chain. Plan gratuito limitado, premium para institucionales." },
  { nombre: "CryptoQuant", url: "https://cryptoquant.com",
    desc: "Foco en flujos de exchange e indicadores de mineros. Buen plan gratuito." },
  { nombre: "LookIntoBitcoin", url: "https://www.lookintobitcoin.com",
    desc: "Indicadores históricos de ciclo de BTC. 100% gratuito y muy didáctico." },
];
